export default __webpack_public_path__ + "static/media/Al-Bahah.f507d96d.mp4";